module.exports = __webpack_public_path__ + "static/media/visa.7ffd65fe.png";